import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable } from 'rxjs/Observable';
import { IDMDonVi } from './dm-don-vi';
@Injectable()
export class DMDonViService {

    controller: string = 'DMDonVi';
    constructor(private http: Http) { }

    DanhSach_DonVi_TheoCoQuan(IdCoQuan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = { IdCoQuan: IdCoQuan };
        return this.http.post(Config.apiUrl + 'DMDonVi/DanhSachDonVi_Theo_CoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetList(idTinhThanh: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdTinhThanh: idTinhThanh
        };
        return this.http.post(Config.apiUrl + this.controller + '/GetList', JSON.stringify(data), { headers: headers }).map(resp => resp.json());

    }

    GetListFromPagination(idTinhThanh: number, idDonVi: number, paging: number, keyword: string, pageSize: number) {
        let headers = new Headers();
        let startRowIndex = paging - 1;

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = { startRowIndex, pageSize };
        return this.http.get(Config.apiUrl + this.controller + '/PaginationDSDonVi?idtinhthanh=' + idTinhThanh + '&idDv=' + idDonVi + '&offset=' + startRowIndex + "&pagesize=" + pageSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());
    }

    GetDonViTrucThuoc(idTinhThanh: number, id: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdTinhThanh: idTinhThanh,
            Id: id
        };
        return this.http.post(Config.apiUrl + this.controller + '/GetDonViTrucThuoc', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    GetCapDonVi() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/GetCapDonVi', '', { headers: headers }).map(resp => resp.json());
    }
   
    GetLoaiDonVi() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/GetLoaiDonVi', '', { headers: headers }).map(resp => resp.json());
    }

    GetCoQuan() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/GetCoQuan', '', { headers: headers }).map(resp => resp.json());
    }

    GetDSDonViMot(id, idTinhThanh) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdTinhThanh: idTinhThanh,
            Id: id
        };
        return this.http.post(Config.apiUrl + this.controller + '/GetDSDonViMot', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetTreeList() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/Tree', JSON.stringify({}), { headers: headers }).map(resp => resp.json());
    }
    GetTreeListTk() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/TreeThongKe', JSON.stringify({}), { headers: headers }).map(resp => resp.json());
    }
    TiemKiemTree(DV) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = DV;
        return this.http.post(Config.apiUrl + this.controller + '/TimKiemTree', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetTreeListByCoQuan(idCoQuan: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + '/TreeByCoQuan?idCoQuan=' + idCoQuan, { headers: headers }).map(resp => resp.json());
    }

    GetItem(ids:string) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = ids;
        return this.http.post(Config.apiUrl + this.controller + '/GetItem', JSON.stringify(data), { headers: headers }).map(resp => resp.json());

    }

    Save(item: IDMDonVi) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller + '/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Delete(id) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            Id: id
        };
        return this.http.post(Config.apiUrl + this.controller + '/delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetTreeDonVi_TheoCoQuan(IdCoQuan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = { IdCoQuan: IdCoQuan };
        return this.http.post(Config.apiUrl + 'DMDonVi/GetTreeDonVi_TheoCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
     KiemTra_CapDonViCha(DV) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = DV;
        return this.http.post(Config.apiUrl + this.controller + '/KiemTraDonViCapCha', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/he-thong/dm-don-vi/dm-don-vi.service.ts